import React, { Fragment } from 'react'
import { Skeleton } from '@material-ui/lab'
import { Box, Chip, Divider, Grid, Typography } from '@material-ui/core'

import { SectionCard } from 'components'

import helpers from 'helpers'

import theme from 'theme'
import constants from 'constants/index'

const InformationSection = ({ dataProcessTreatment, isLoading }) => {
  const dataProcess = dataProcessTreatment?.dataProcess

  const storageTime = helpers.formatters.storageTime({
    storageMode: dataProcess?.storageMode,
    value: dataProcess?.value,
    volumetry: dataProcess?.volumetry,
  })

  const dataSources = dataProcess?.dataProcessDataSources?.map(
    (dataSource) => dataSource.sourceDescription,
  )

  const treatmentChipColor =
    constants.dataProcessTreatment.CHIP_STATUS_COLOR[
      dataProcessTreatment?.status
    ]

  const treatmentChipTextColor =
    constants.dataProcessTreatment.CHIP_STATUS_TEXT_COLOR[
      dataProcessTreatment?.status
    ]

  const treatmentChipLabel =
    constants.dataProcessTreatment.CHIP_STATUS_LABEL[
      dataProcessTreatment?.status
    ]

  const GENERAL_INFORMATION_ITENS = [
    { label: 'Identificador', value: dataProcess?.id },
    { label: 'Nome do registro', value: dataProcess?.name },
    { label: 'Departamento', value: dataProcess?.department?.name },
    { label: 'Código', value: dataProcess?.code },
    { label: 'Tempo de armazenamento', value: storageTime },
    { label: 'Origem dos dados', value: dataSources },
    {
      label: 'Por que o dado é tratado? (finalidade)',
      value: dataProcess?.finality,
    },
  ]

  const PROCESS_RISK_ITENS = [
    {
      label: 'Risco do processo',
      value: dataProcess?.dataProcessRisk,
      chip: 'risk',
    },
    { label: 'Status', value: dataProcess?.statusId, chip: 'status' },
    // { label: 'Tipo de dado', value: 'null' },
    // { label: 'Compartilhamento', value: 'null' },
    // { label: 'Forma de armazenamento', value: 'null' },
    // { label: 'Disposição dos dados (Forma de eliminação)', value: 'null' },
  ]

  return (
    <SectionCard
      title={
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          gridGap={theme.spacing(2)}
        >
          {isLoading ? (
            <Fragment>
              <Skeleton variant="text" width="40%" />
              <Skeleton variant="text" width={100} />
            </Fragment>
          ) : (
            <Fragment>
              <Typography variant="h6">{`#${dataProcess?.id} ${dataProcess?.name}`}</Typography>
              <Chip
                size="small"
                label={treatmentChipLabel || 'Não definido'}
                style={{
                  backgroundColor: treatmentChipColor,
                  color: treatmentChipTextColor,
                }}
              />
            </Fragment>
          )}
        </Box>
      }
    >
      <Box display="flex" flexDirection="column" gridGap={theme.spacing(3)}>
        <Typography variant="h5">Informações Gerais</Typography>
        <Grid container spacing={2}>
          {GENERAL_INFORMATION_ITENS.map((item, index) => (
            <Grid key={index} item xs={12} md={6}>
              <Typography variant="subtitle2" color="textSecondary">
                {item.label}
              </Typography>
              {isLoading ? (
                <Skeleton variant="text" width="100%" />
              ) : Array.isArray(item.value) ? (
                item.value.map((value, index) => (
                  <Typography key={index} color="textPrimary" variant="body2">
                    {value}
                  </Typography>
                ))
              ) : (
                <Typography color="textPrimary" variant="body2">
                  {item?.value || 'Não definido'}
                </Typography>
              )}
            </Grid>
          ))}
        </Grid>
        <Divider />
        <Typography variant="h5">Risco do processo</Typography>
        <Grid container spacing={2}>
          {PROCESS_RISK_ITENS.map((item, index) => {
            const chipColor =
              item.chip === 'status'
                ? constants.dataProcess.CHIP_STATUS_COLOR[item.value]
                : item?.value?.color

            const chipTextColor =
              item.chip === 'status'
                ? constants.dataProcess.CHIP_STATUS_TEXT_COLOR[item.value]
                : item?.value?.secondaryColor

            const chipLabel =
              item.chip === 'status'
                ? constants.dataProcess.CHIP_STATUS_LABEL[item.value]
                : item?.value?.label

            return (
              <Grid key={index} item xs={12} md={6}>
                <Typography variant="subtitle2" color="textSecondary">
                  {item.label}
                </Typography>
                {isLoading ? (
                  <Skeleton variant="text" width="100%" />
                ) : !!item?.chip ? (
                  <Chip
                    size="small"
                    label={chipLabel || 'Não definido'}
                    style={{
                      ...(chipColor && {
                        backgroundColor: chipColor,
                        color:
                          chipTextColor ||
                          theme.palette.getContrastText(chipColor),
                      }),
                      fontWeight: 700,
                    }}
                  />
                ) : (
                  <Typography color="textPrimary" variant="body2">
                    {item.value || 'Não definido'}
                  </Typography>
                )}
              </Grid>
            )
          })}
        </Grid>
        {/* <Alert severity="info" icon={false}>
          O risco calculado considera os seguintes fatores: Tipo de Dado,
          Compartilhamento e Forma de Armazenamento. O fator Tipo de Dado
          (Sensível) tem Risco 4, o fator Compartilhamento (Interno e Externo)
          tem Risco 3, o fator Forma de Armazenamento (Eletrônica) tem Risco 2,
          resultando no Risco Total de = 24 (Severo).
        </Alert> */}
      </Box>
    </SectionCard>
  )
}

export default InformationSection
